import React from 'react'

const Search = () => {
  return (
    <svg
      fill='none'
      height='30'
      viewBox='0 0 26 26'
      width='30'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M11.47 21.5c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10zM24.47 24.5l-5.929-4.929'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
      />
    </svg>
  )
}

export default Search
